'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Adapter Type
 */
exports.default = _propTypes2.default.shape({
  scatterer: _propTypes2.default.shape({
    unmount: _propTypes2.default.func.isRequired,
    render: _propTypes2.default.func.isRequired,
    addHandlerListener: _propTypes2.default.func.isRequired
  }),
  materializer: _propTypes2.default.shape({
    addUnmountListener: _propTypes2.default.func.isRequired,
    addRenderListener: _propTypes2.default.func.isRequired,
    handle: _propTypes2.default.func.isRequired
  })
});